import request from './base'

export const carTypeManageList = (params) => {
    return request.post("/admin/v1/carTypeManage/list", params)
}

export const carTypeManageAdd = (params) => {
    return request.post("/admin/v1/carTypeManage/add", params)
}

export const carTypeManageModify = (params) => {
    return request.post("/admin/v1/carTypeManage/modify", params)
}

export const carTypeManageDelete = (params) => {
    return request.post("/admin/v1/carTypeManage/delete", params)
}




// WEBPACK FOOTER //
// ./src/api/carTypeManage.js